import { useEffect } from "react";
import { API_CALLS } from "../../../../../API/api_calls";
import { actions, useAppDispatch, useAppSelector } from "../../../../../redux";
import { POST_ANALYSIS_MODAL_WIDTH } from "../../../../../utils";
import { Modal } from "../../../../Common";
import ModalContent from "./ModalContent";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";

const PostAnalysisModal = () => {
  const dispatch = useAppDispatch();
  const { postAnalysisModalOpen, active_post_id, post_analysis_list } =
    useAppSelector((state) => state.postAnalysis);

  useEffect(() => {
    if (active_post_id && !post_analysis_list[active_post_id]) {
      API_CALLS.METADATA_POSTS.getPostMetadata(active_post_id);
    }
  }, [active_post_id, post_analysis_list]);

  return (
    <div>
      {postAnalysisModalOpen && (
        <Modal
          from="default-post"
          type="Pages"
          maxWidth={POST_ANALYSIS_MODAL_WIDTH}
          padding={100}
          showCloseButton
          setCloseButton={() => {
            dispatch(actions.postAnalysis.setPostAnalysisModalOpen(false));
            dispatch(actions.postAnalysis.setActivePostId(""));
          }}
        >
          <ModalHeader />
          <ModalContent />
          <ModalFooter />
        </Modal>
      )}
    </div>
  );
};

export default PostAnalysisModal;
